import React from 'react';
import type { SvgProps } from 'react-native-svg';
import { Path, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface SunIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

const SunIcon: React.FC<SunIconProps> = ({
  size = 16,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();

  return (
    <Svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8.75L14.2222 8.75L14.2222 7.25L16 7.25L16 8.75ZM8.75 -3.16908e-07L8.75 1.77778L7.25 1.77778L7.25 -3.82475e-07L8.75 -3.16908e-07ZM11.8693 12.9304L13.1264 14.1874L14.187 13.1268L12.9299 11.8697L11.8693 12.9304ZM1.81255 13.1268L3.06963 11.8697L4.13029 12.9304L2.87321 14.1874L1.81255 13.1268ZM8.75 16L8.75 14.2222L7.25 14.2222L7.25 16L8.75 16ZM1.77778 8.75L5.712e-07 8.75L6.36767e-07 7.25L1.77778 7.25L1.77778 8.75ZM1.81285 2.87308L3.06993 4.13016L4.13059 3.0695L2.87351 1.81242L1.81285 2.87308ZM11.8698 3.07036L13.1269 1.81329L14.1876 2.87395L12.9305 4.13102L11.8698 3.07036ZM4.30556 8C4.30556 5.95961 5.95962 4.30556 8 4.30556C10.0404 4.30556 11.6944 5.95961 11.6944 8C11.6944 10.0404 10.0404 11.6944 8 11.6944C5.95962 11.6944 4.30556 10.0404 4.30556 8ZM8 2.80556C5.13119 2.80556 2.80556 5.13119 2.80556 8C2.80556 10.8688 5.13119 13.1944 8 13.1944C10.8688 13.1944 13.1944 10.8688 13.1944 8C13.1944 5.13119 10.8688 2.80556 8 2.80556Z"
        fill={colors[color]}
      />
    </Svg>
  );
};

SunIcon.displayName = 'SunIcon';
export { SunIcon };
